import { delay, http, HttpResponse } from 'msw';
import { IFeatureFlagrResponse } from 'services/featureFlagr/types';

const featureFlag = [
  http.get(`${process.env.BFF_URL}company/check-feature-flag/:featureId`, async () => {
    const mockResponse: IFeatureFlagrResponse = {
      access: true,
    };
    await delay(1000);

    return HttpResponse.json(mockResponse);
  }),
];

export { featureFlag };
